<template>
  <div>
    <v-row class="mt-0" no-gutters>
      <v-spacer />
      <v-col cols="4">
        <v-select
          v-model="diagnostico"
          :items="diagnosticos"
          item-text="nome"
          item-value="id"
          label="Diagnóstico:"
          return-object
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card-widget title="Informações">
          <div slot="widget-content">
            <v-row no-gutters>
              <v-col cols="6">
                <span class="font-weight-bold">Diagnóstico: </span>
                <span class="font-weight-light">{{
                  diagnostico.nome ? diagnostico.nome : ""
                }}</span>
              </v-col>
              <v-col v-if="inicio && fim" cols="6">
                <span class="font-weight-bold">Período: </span>
                <span class="font-weight-light">{{ inicio | date }} até {{ fim | date }}</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col v-if="unidade.id" cols="6">
                <span class="font-weight-bold">Unidade: </span>
                <span class="font-weight-light">{{ unidade.sigla }} - {{ unidade.nome }}</span>
              </v-col>
              <v-col v-if="avaliado !== ''" cols="6">
                <span class="font-weight-bold">Avaliado(a): </span>
                <span class="font-weight-light">{{ avaliado }}</span>
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-widget :title="titulo ? titulo : 'Formulário'">
          <div v-if="isDispensado" slot="widget-content">
            <info-dispensa
              :mensagem="`A participação no diagnóstico não está disponível. (${motivoDispensa})`"
            />
          </div>
          <div v-else slot="widget-content">
            <AppTutorial :tutorial="visibleTutorial" />
            <v-row
              v-if="prazoEsgotado && usuarioMapeamento.tipo == 'REGULAR'"
              no-gutters
            >
              <v-col>
                <v-col>
                  <app-alert
                    icon="watch_later"
                    message="O prazo para participação está esgotado. Obrigado pela sua colaboração."
                    type="warning"
                  />
                </v-col>
              </v-col>
            </v-row>
            <v-row
              v-else-if="prazoFuturo && usuarioMapeamento.tipo == 'REGULAR'"
              no-gutters
            >
              <v-col>
                <app-alert
                  icon="watch_later"
                  message="O prazo para participação ainda não está disponível."
                  type="info"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <!-- Slot Body -->
              <slot name="body" />
            </v-row>
          </div>
          <div v-if="!prazoEsgotado && !prazoFuturo" slot="widget-actions">
            <v-row no-gutters>
              <v-col cols="12">
                <!-- Slot Actions-->
                <slot name="actions" />
              </v-col>
            </v-row>
          </div>
        </v-card-widget>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VCardWidget from '@/components/VWidget';
import InfoDispensa from '@/components/diagnostico/InfoDispensa';
import AppTutorial from '@/components/core/AppTutorial';
import Data from '@/modules/data';

export default {
  name: 'AppDiagnostico',

  components: {
    VCardWidget,
    InfoDispensa,
    AppTutorial,
  },

  props: {
    titulo: {
      type: String,
      default: '',
    },
    inicio: {
      type: String,
      default: null,
    },
    fim: {
      type: String,
      default: null,
    },
    avaliado: {
      type: String,
      default: '',
    },
    gestorGestores: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    diagnostico: {
      get() {
        return this.$store.state.diagnostico.diagnostico;
      },
      set(diagnostico) {
        this.$store.dispatch('diagnostico/setDiagnostico', diagnostico);
      },
    },
    diagnosticos: {
      get() {
        return this.$store.state.diagnostico.diagnosticos;
      },
      set(diagnosticos) {
        this.$store.dispatch('diagnostico/setDiagnosticos', diagnosticos);
      },
    },
    ...mapState({
      mapeamento: (state) => state.mapeamento.mapeamento,
      isDispensado: (state) => state.diagnostico.dispensado,
      motivoDispensa: (state) => state.diagnostico.motivoDispensa,
      usuarioMapeamento: (state) => state.mapeamento.usuarioMapeamento,
    }),
    unidade() {
      if (this.usuarioMapeamento.tipo === 'REGULAR') {
        return this.usuarioMapeamento.unidade;
      }
      if (this.usuarioMapeamento.tipo === 'COMPLEMENTAR') {
        return this.mapeamento.unidade;
      }
      return null;
    },
    prazoEsgotado() {
      return this.fim && Data.compare('isAfter', { b: this.fim });
    },
    prazoFuturo() {
      return this.inicio && Data.compare('isBefore', { b: this.inicio });
    },
    visibleTutorial() {
      switch (this.$route.name) {
        case 'AutoAvaliacaoComportamento':
          return 'Autoavaliacao';
        case 'AvaliacaoChefiaComportamento':
          return 'AvaliacaoGestor';
        case 'AvaliacaoServidoresComportamento':
          return 'AvaliacaoEquipe';
        case 'AvaliacaoParesComportamento':
          return 'AvaliacaoPares';
        case 'AvaliacaoServidoresResponsabilidade':
          if (this.gestorGestores) {
            return 'AvaliacaoEquipeResponsabilidadeGestorUnidades';
          }
          return 'AvaliacaoEquipeResponsabilidadeGestorUnidade';
        case 'AutoAvaliacaoResponsabilidade':
          return 'AutoavaliacaoResponsabilidade';
        default:
          return '';
      }
    },
  },

  watch: {
    diagnostico() {
      this.load();
    },
  },

  created() {
    this.load();
  },

  methods: {
    load() {
      if (this.diagnostico) {
        this.$store.dispatch('diagnostico/loadAvaliacoes', this.diagnostico.id);
      }
    },
  },
};
</script>
